import React, { useEffect, useState } from 'react'
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar'
import Input from "../../../../../core/Inputs/DefaultInput";
import style from "../../../../style.module.css";
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { addPage, changeReportName, deletePage, duplicatePage, getReportDetails, reOrderPages, stopEditMode, toggleReportPage6, updatePage } from '../../../../../store/actions/reportAction'
import { useSelector } from 'react-redux'
import { CLEAR_REPORT_DETAILS, SET_CURRENT_REPORT } from '../../../../../store/constant'
import { useVerifySurveyId } from '../../../../../hooks'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Svg from '../../../../../component/common/Svg';
import { Card } from '@material-ui/core';
import { useRef } from 'react';
import CustomGrapeEditor from './GrapeEditor/CustomGrapeEditor';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ReportImg2 from '../../../../../assets/images/report-2.png'
import PageThumbnail from './components/PageThumbnail';

import { useTranslation } from 'react-i18next';

export default function Templates() {
    //==> States <==
    const { t, i18n } = useTranslation();
    const [currentPage, setcurrentPage] = useState()
    const [pages, setPages] = useState([])
    const [sortablePages, setSortablePages] = useState([])
    const [reportInfo, setReportInfo] = useState([])
    const [isVisibleCollapse, setIsVisibleCollapse] = useState(true)
    const [currentlyDeletingPage, setCurrentlyDeletingPage] = useState(null)
    const [editor, setEditor] = useState(null)
    const [saveReportBtnText, setSaveReportBtnText] = useState(t('survey.report.saver'))
    const currentPageContent = useRef(null)

    //Others
    const dispatch = useDispatch()
    const { isEditMode, reportDetails, currentReport } = useSelector((state) => state.reportData)
    const { survey_name } = useSelector((state) => state.permissionsData)
    const survey_id = useVerifySurveyId()
    const language_code = '22'


    //==> React-beautiful-dnd <==
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    }

    const onDragEnd = (result) => {
        if (window.modulePermissions.M13.edit != 1) {
            return;
        }
        if (!result.destination) {
            return;
        }

        if (result.destination.index === result.source.index) {
            return;
        }

        const sortedPages = reorder(
            sortablePages,
            result.source.index,
            result.destination.index
        )
        setSortablePages(sortedPages)

        const order = {}
        sortedPages?.forEach((page, index) => {
            order[page.id] = index + 1
        })

        const payload = {
            report_id: currentReport,
            order
        }
        dispatch(reOrderPages(payload))
    }


    //==> FORM SCHEMA AND VALIDATION <==
    //Yup - Schema
    const formSchema = Yup.object().shape({
        reportName: Yup.string().trim().required('Report name required'),
    })

    //Formik - Validation
    const initialValues = {
        reportName: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: formSchema,
    })

    const { values, handleChange, handleBlur, touched, errors, setFieldValue } = formik



    //==> FUNCTIONALITIES <==
    const handlePageChange = (page) => {
        if (page.id === currentPage.id) {
            return
        }

        setcurrentPage(page)
        handleUpdatePageData(editor, currentPage)
    }

    const handleAddPage = (pageNo) => {
        const afterAdd = (data) => {
            setcurrentPage(data)
        }
        const payload = {
            report_id: currentReport,
            survey_id,
            pageNo,
            content: '',
            css: ''
        }
        handleUpdatePageData(editor, currentPage)
        dispatch(addPage(payload, afterAdd))
    }

    const handleDeletePage = (page) => {
        const payload = {
            page_id: page?.id
        }
        dispatch(deletePage(payload))
        if (page?.id === currentPage?.id) {
            const tmpPage = pages?.filter((p) => Number(p.page_no) === Number(page.page_no) - 1)
            if (tmpPage)
                setcurrentPage(tmpPage[0])
        }
    }

    //Data handling
    const handleDelete = (page, e) => {
        e.stopPropagation()
        setCurrentlyDeletingPage(page)
    }

    const handleSavePage = (editor, currentPage) => {
        let pageHtml = editor?.getHtml();
        let pageCss = editor?.getCss();
        setcurrentPage((old) => ({ ...old, content: pageHtml, css: pageCss }))
        handleUpdatePageData(editor, currentPage)

        //Independant event (Not connected with success of an API )
        setSaveReportBtnText('Saving .........')
        setTimeout(() => {
            setSaveReportBtnText(t('survey.report.saver'))
        }, 500);
    }

    const handleDuplicate = (page, e) => {
        const successCallback = (page) => {
            setcurrentPage(page)
        }

        e.stopPropagation()
        const payload = {
            page_id: page.id,
            page_order: pages.length,
        }
        dispatch(duplicatePage(payload, page, successCallback))
    }

    //Encode - Decode
    const htmlDecode = (input) => {
        const textArea = document.createElement("textarea");
        textArea.innerHTML = input;
        return textArea.value;
    }

    const htmlEncode = (input) => {
        const textArea = document.createElement("textarea");
        textArea.innerText = input;
        return textArea.innerHTML.split("<br>").join("\n");
    }

    //Report name change
    const handleNameBlur = (e, value) => {
        handleBlur(e)
        const payload = {
            report_id: currentReport,
            language_code: language_code,
            name: value
        }
        dispatch(changeReportName(payload))
    }

    //Update page data
    const handleUpdatePageData = (editedPageData, currentPage) => {
        let pageHtml = editedPageData?.getHtml();
        let pageCss = editedPageData?.getCss();
        // let pageCss = editedPageData
        pageHtml = pageHtml?.replaceAll('http://bis-frnt-dev.digitalapple.in/images', '../images')
        pageCss = pageCss?.replaceAll('http://bis-frnt-dev.digitalapple.in/images', '../images')
        pageHtml = htmlEncode(pageHtml ?? '')

        const payload = {
            css: pageCss,
            content: pageHtml,
            page_id: currentPage?.id
        }
        if (pageHtml && currentPage?.id) {
            dispatch(updatePage(payload))
        }
    }



    //==> Effects <==
    useEffect(() => {
        return () => {
            if (isEditMode) {
                dispatch(stopEditMode())
            }
            dispatch({ type: CLEAR_REPORT_DETAILS })
        }
    }, [])

    useEffect(() => {
        if (currentReport) {
            const payload = {
                report_id: currentReport
            }
            dispatch(getReportDetails(payload))
        }
    }, [currentReport, dispatch])

    useEffect(() => {
        if (reportDetails) {
            const { reportData, reportPages } = reportDetails
            setReportInfo(reportData)
            let orderedPages = reportPages?.sort((a, b) => Number(a.page_no) - Number(b.page_no))

            if (!currentPage && orderedPages) {
                setcurrentPage(orderedPages[0])

            }
            setPages(orderedPages)
        }
    }, [currentPage, reportDetails])

    useEffect(() => {
        if (reportInfo && currentPage && currentPage.page_no === 1) {
            let name = reportInfo.su_survey_report_name && JSON.parse(reportInfo.su_survey_report_name)[language_code]
            setFieldValue('reportName', name ?? '')
        }
    }, [currentPage, reportInfo, setFieldValue])

    useEffect(() => {
        if (!editor) return undefined

        let cancelled = false

        const syncPageIntoEditor = () => {
            if (cancelled) return
            try {
                // Stale React state can still hold a ref after child destroy(); model is gone.
                if (!editor.getModel?.()) return

                let content = currentPage?.content
                content = content?.replaceAll('../images', 'http://bis-frnt-dev.digitalapple.in/images')
                editor.setComponents(htmlDecode(content ?? ''))

                let pageCss = currentPage?.css
                if (pageCss) {
                    editor.setStyle(pageCss)
                } else if (reportDetails) {
                    let reportCss = reportDetails.reportCss
                    reportCss = reportCss ? reportCss[0]?.css : ''
                    if (reportCss) {
                        editor.setStyle(reportCss)
                    }
                }
            } catch {
                /* destroyed or canvas not ready */
            }
        }

        syncPageIntoEditor()
        const t0 = window.setTimeout(syncPageIntoEditor, 0)
        const t1 = window.setTimeout(syncPageIntoEditor, 80)

        return () => {
            cancelled = true
            window.clearTimeout(t0)
            window.clearTimeout(t1)
            try {
                if (editor.getModel?.()) {
                    editor.setComponents('')
                    editor.setStyle('')
                }
            } catch {
                /* editor instance may already be destroyed (GrapesJS) */
            }
        }
    }, [currentPage, editor, reportDetails])

    useEffect(() => {
        setSortablePages(pages)
    }, [pages])


    return (
        <div className='d-flex flex-column main-outer-wrapper main-site-wrapper'>
            <SurveyListHeader />
            <div className="flex-grow-1 d-flex survey-main-wrapper">
                <SurveyListSidebar />
                <div id="content" className="flex-grow-1 dashboard-page-outer report-templates d-flex flex-column">
                    {/* <ReportSubHeader /> */}

                    <div className="survey-design-container d-flex flex-grow-1">
                        {/**New Sidebar Code */}
                        {/* <div className="design-sidebar"> */}
                        {/**Add Class Closed when Clicked on "Templates Button" */}
                        {/* <div className="report-header-sidebar d-flex justify-content-between align-items-center">
                                <h3>Templates</h3>
                                <button className='close'>
                                    <svg width={45} height={45} viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.5439 16.5439L27.5733 27.5733" stroke="#728095" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M16.5439 27.5733L27.5732 16.5439" stroke="#728095" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>

                                </button>
                            </div> */}
                        {/* <div className="design-default-sidebar"> */}
                        {/* <div className="button-wrap">
                                    <button className='btn btn-primary w-100'>Create template</button>
                                </div> */}
                        {/* <div className="recently-used reports-wrap">
                                    <div className="heading d-flex justify-content-between align-items-center">
                                        <h4>Recently used</h4>
                                        <Link to="/admin/survey/report/builder" className='btn-link'>View all</Link>
                                    </div>
                                    <div className="report-list">
                                        <a href="" className="report-inner">
                                            <div className="report-img">
                                                <img src={ReportImg1} className="img-fluid" />
                                            </div>
                                        </a>
                                        <a href="" className="report-inner">
                                            <div className="report-img">
                                                <img src={ReportImg2} className="img-fluid" />
                                            </div>
                                        </a>
                                        <a href="" className="report-inner">
                                            <div className="report-img">
                                                <img src={ReportImg3} className="img-fluid" />
                                            </div>
                                        </a>

                                    </div>
                                </div> */}
                        {/* <div className="recently-used reports-wrap">
                                    <div className="heading d-flex justify-content-between align-items-center">
                                        <h4>All results</h4>
                                        <a href="#" className='btn-link'>View all</a>
                                    </div>
                                    <div className="report-list">
                                        <a href="" className="report-inner">
                                            <div className="report-img">
                                                <img src={ReportImg1} className="img-fluid" />
                                            </div>
                                        </a>
                                        <a href="" className="report-inner">
                                            <div className="report-img">
                                                <img src={ReportImg2} className="img-fluid" />
                                            </div>
                                        </a>
                                        <a href="" className="report-inner">
                                            <div className="report-img">
                                                <img src={ReportImg3} className="img-fluid" />
                                            </div>
                                        </a>
                                    </div>
                                </div> */}
                        {/* </div> */}
                        {/* </div> */}


                        {/**Right Bar Code */}
                        <div className='flex-grow-1 w-100 page-content-wrap report-height'>
                            <div className="page-heading d-flex align-items-center justify-content-between">
                                <div className="head-lef">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/admin/survey/list">{t('survey.title')}</Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name}</Link>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page"><strong>{t('survey.report.title')}</strong></li>
                                        </ol>
                                    </nav>
                                    <h2>{t('survey.report.title')}</h2>
                                </div>
                                <div className="button-group-custom d-flex align-items-center">
                                    {window.modulePermissions.M13.edit == 1 && (<div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginRight: '16px' }}>
                                        <div
                                            onClick={() => {
                                                const isOn = reportDetails?.reportData?.show_page6 === 1 || reportDetails?.reportData?.show_page6 === undefined;
                                                dispatch(toggleReportPage6({ report_id: currentReport, show_page6: isOn ? 0 : 1 }))
                                            }}
                                            style={{
                                                width: '48px', height: '26px', borderRadius: '13px', cursor: 'pointer',
                                                background: (reportDetails?.reportData?.show_page6 === 1 || reportDetails?.reportData?.show_page6 === undefined) ? '#E60000' : '#ccc',
                                                position: 'relative', transition: 'background 0.25s',
                                            }}
                                        >
                                            <div style={{
                                                width: '22px', height: '22px', borderRadius: '50%', background: '#fff',
                                                position: 'absolute', top: '2px',
                                                left: (reportDetails?.reportData?.show_page6 === 1 || reportDetails?.reportData?.show_page6 === undefined) ? '24px' : '2px',
                                                transition: 'left 0.25s', boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
                                            }} />
                                        </div>
                                        <span style={{
                                            fontWeight: 500, fontSize: '13px', userSelect: 'none', whiteSpace: 'nowrap',
                                            color: (reportDetails?.reportData?.show_page6 === 1 || reportDetails?.reportData?.show_page6 === undefined) ? '#E60000' : '#999',
                                        }}>
                                            {t('survey.report.showPage6')}
                                        </span>
                                    </div>)}
                                    <Link to={`/admin/survey/report/builder?survey_id=${survey_id}`}>
                                        <button className='btn btn-bordered color-cancel'>{t('survey.customVariable.cancel')}</button>
                                    </Link>
                                    {window.modulePermissions.M13.edit == 1 && (<button className='btn btn-primary add-btn ms-3' onClick={() => handleSavePage(editor, currentPage)}>{saveReportBtnText}</button>)}
                                </div>


                            </div>
                            <div className="containr">
                                {
                                    currentPage && currentPage.page_no === 1 && <div className="mb-3">
                                        <label htmlFor="" className='form-label-custom'>{t('survey.report.temp_name')}</label>
                                        <div className="position-relative">
                                            <Input
                                                type='text'
                                                view='outlined'
                                                dense={false}
                                                color='default'
                                                label=''
                                                placeholder={t('survey.report.temp_name')}
                                                clearButton={window.modulePermissions.M13.edit == 1}
                                                success={false}
                                                error={false}
                                                fill={true}
                                                errorHelperText={null}
                                                className={"formsinput"}
                                                name='reportName'
                                                value={values.reportName}
                                                onChange={window.modulePermissions.M13.edit == 1 ? handleChange : undefined}
                                                onBlur={window.modulePermissions.M13.edit == 1 ? (e) => handleNameBlur(e, values.reportName) : undefined}
                                                onClear={window.modulePermissions.M13.edit == 1 ? () => setFieldValue('reportName', '') : undefined}
                                                readOnly={window.modulePermissions.M13.edit != 1}
                                            />
                                            {touched.reportName && errors.reportName && <div className="validation-msg">{errors.reportName}</div>}
                                        </div>
                                    </div>
                                }
                                {/* <h4>Page content</h4> */}
                                <div className={`editor-wrapper ${isVisibleCollapse ? '' : 'drawer-closed'} ${window.modulePermissions.M13.edit != 1 ? 'report-templates-readonly' : ''}`} style={{ border: '1px solid #dddddd', borderRadius: '3px', minHeight: '200px' }}>
                                    {/* <EditorMultipleChoice/> */}
                                    {/* <CustomEditor
                                        pageData={pageData}
                                        currentPageContent={currentPageContent}
                                    /> */}

                                    <CustomGrapeEditor
                                        editor={editor}
                                        setEditor={setEditor}
                                        currentReport={currentReport}
                                        currentPage={currentPage}
                                        readOnly={window.modulePermissions.M13.edit != 1}
                                    />
                                </div>
                            </div>

                            <div className="bottom-drawer">
                                <DragDropContext onDragEnd={onDragEnd}>
                                    <div className="drawer-list">
                                        <button className={`round-buttn ${isVisibleCollapse ? '' : 'collapsed'}`}
                                            onClick={() => { setIsVisibleCollapse(!isVisibleCollapse) }}
                                            type="button"
                                            aria-expanded="false" aria-controls="collapseExample">
                                            <svg width={11} height={12} viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1.86988 7.79785L4.85822 4.73678C5.21113 4.37527 5.78863 4.37527 6.14155 4.73678L9.12988 7.79785" stroke="#2979FF" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                        <Droppable droppableId="reportPagesSelection" direction='horizontal' >
                                            {provided => (
                                                <div className={`collapse ${isVisibleCollapse ? 'show' : ''}`} id="collapseExample" ref={provided.innerRef} {...provided.droppableProps} >
                                                    <div className="drw-list">
                                                        {window.modulePermissions.M13.add == 1 && (<div className="drawer-wrap add-btn" title="Add Screen" onClick={() => handleAddPage(pages ? pages?.length + 1 : 1)}>
                                                            <div className="drawer-inner">
                                                                <svg width={108} height={108} viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M27 54H81" stroke="#2773FF" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
                                                                    <path d="M54 81V27" stroke="#2773FF" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                            </div>
                                                        </div>)}
                                                        {
                                                            sortablePages && sortablePages.length > 0 && sortablePages.map((page, index) => {
                                                                return (
                                                                    <Draggable draggableId={`reportPageList${index}`} index={index} key={index} isDragDisabled={window.modulePermissions.M13.edit != 1}>
                                                                        {
                                                                            (provided) => (
                                                                                <div
                                                                                    className={`drawer-wrap ${currentPage?.id === page.id ? 'active-page' : ''}`}
                                                                                    key={index}
                                                                                    onClick={() => handlePageChange(page)}
                                                                                    ref={provided.innerRef}
                                                                                    {...provided.draggableProps}
                                                                                    {...provided.dragHandleProps}
                                                                                >
                                                                                    <div className="drawer-inner">
                                                                                        {(window.modulePermissions.M13.add == 1 || window.modulePermissions.M13.del == 1) && (
                                                                                        <div className="dropdown table-dropdown">
                                                                                            <button className="btn dropdown-tgl" type="button" id="viewoptions" data-bs-toggle="dropdown"
                                                                                                aria-haspopup="true" aria-expanded="false" onClick={(e) => e.stopPropagation()}>
                                                                                                <Svg name="action" />
                                                                                            </button>
                                                                                            <div className="dropdown-menu" aria-labelledby="viewoptions">
                                                                                                {window.modulePermissions.M13.add == 1 && (<span className="dropdown-item d-flex align-items-center" onClick={(e) => handleDuplicate(page, e)}>
                                                                                                    <div className="icon-circle me-3">
                                                                                                        <Svg name="duplicate" />
                                                                                                    </div>
                                                                                                    <span>Duplicate</span>
                                                                                                </span>)}
                                                                                                {window.modulePermissions.M13.del == 1 && (
                                                                                                <span className="dropdown-item d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#deleteReportPageModal" onClick={(e) => handleDelete(page, e)}>
                                                                                                    <div className="icon-circle me-3">
                                                                                                        <Svg name="delete" />
                                                                                                    </div>
                                                                                                    <span>{t('survey.report.delete')}</span>
                                                                                                </span>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                        )}
                                                                                        {/* <PageThumbnail
                                                                                            css={page.css}
                                                                                            html={page.content}
                                                                                            pageId={page.id}
                                                                                        /> */}
                                                                                        <div className="counter-big">{index + 1}</div>
                                                                                        {/* <img src={ReportImg2} className="img-fluid" /> */}
                                                                                    </div>
                                                                                    {/* <div className="count">{index + 1}</div> */}
                                                                                </div>
                                                                            )
                                                                        }
                                                                    </Draggable>
                                                                )
                                                            })
                                                        }
                                                        {provided.placeholder}
                                                    </div>
                                                </div>
                                            )}
                                        </Droppable>
                                    </div>
                                </DragDropContext>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="customvar-modal modal custom-modal fade deleteModal" id="deleteReportPageModal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer" + " " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm" + " " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0" + " " + style.card} >
                                        <div className="delete-body-wrap delete-language">
                                            <div className="heading">
                                                <h3>{t('survey.report.del1')}</h3>
                                                <p>{t('survey.report.del2')} </p>
                                            </div>

                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered" data-bs-dismiss="modal" onClick={() => setCurrentlyDeletingPage(null)}>{t('survey.customVariable.cancel')}</button>
                                                {window.modulePermissions.M13.del == 1 && (
                                                <button type="button" className="btn btn-delete ms-3" data-bs-dismiss="modal" onClick={() => handleDeletePage(currentlyDeletingPage)}>{t('survey.customVariable.confirm_delete')}</button>
                                                )}
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
